import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const NewHampshireFisherCatsLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=NHCM_MYTIXX&orgid=57690#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DNHCM_MYTIXX%26orgid%3D57690"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your New Hampshire Fisher Cats account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <NewHampshireFisherCatsLink /> account
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title:
      "How does the New Hampshire Fisher Cats Buy More Save More Program work?",
    description:
      "The New Hampshire Fisher Cats Buy More Save More Program allows fans to select games & seats for the season! The more games you select, the more savings and experience you unlock. Simply log into your MLB.com and select your games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your New Hampshire Fisher Cats{" "}
        <NewHampshireFisherCatsLink /> Account.
      </>
    ),
  },
  {
    title:
      "How do I find out more information about the batting practice experience at Delta Dental Stadium?",
    description:
      "If you are eligible for an entry to win the battering practice experience at Delta Dental Stadium, the box office will reach out to you with any additional details as well as selection information.",
  },
];
